<template>
    <div :class="'badge badge-' + $helpers.resolvePlaylistStatusBadge(status, type)">{{
        status
    }}</div>
</template>
<script>
export default {
    props: {
        status: String|Number,
        type: {
            type: String,
            default: 'playlist'
        }
    },
}
</script>
